import React from 'react';
import MowLogo from '../assets/logos/mow-logo.svg';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-150 to-neutral-200 flex items-center justify-center relative">
      <img 
        src={MowLogo} 
        alt="Ministry of Wine" 
        className="absolute top-8 left-8 h-12 z-10"
      />
      {children}
    </div>
  );
};

export default AuthLayout;
